import React, {  useEffect,useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import './Assets/Css/home.css'

import { FaWhatsapp } from "react-icons/fa";
import { FaAnglesUp } from "react-icons/fa6";


import ScrollToTop from './Webpages/ScrollToTop'

import WebHeader from './Components/WebHeader'
import WebFooter from './Components/WebFooter'
import HomePage from './Webpages/HomePage'
import About from './Webpages/About';
import Contact from './Webpages/Contact';
import Services from './Webpages/Services';
import SecurityServices from './Webpages/SecurityServices';

import CivilConstruction from './Webpages/CivilConstruction';
import RoutineMaintenance from './Webpages/RoutineMaintenance';
import FabricationErection from './Webpages/FabricationErection';
import MarkLineServices from './Webpages/MarkLineServices';
import ManPowerServices from './Webpages/ManPowerServices';
import KNGPage from './Webpages/KNGPage';
import OurTeam from './Webpages/OurTeam';
import AOS from 'aos';
import 'aos/dist/aos.css';









// Pages
const App = () => {

   useEffect(() => {
        AOS.init({ duration: 1000 });
      }, []);

  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (window.scrollY > window.innerHeight / 2) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

 

  return (
    <BrowserRouter>
      
        <WebHeader/>
        <div>
          <ScrollToTop/>
        <Routes>

          <Route path="*" name="HomePage" element={<HomePage />} />
          <Route path="/" name="HomePage" element={<HomePage/>} />
          <Route path="/aboutus" name="About" element={<About/>} />
      {/* <Route path="/services" name="Services" element={<Services/>} /> */}
       <Route path="/security" name="Security and Housekeeping Services" element={<SecurityServices/>} />
        <Route path="/manpowerservice" name="Manpower Services" element={<ManPowerServices/>} />
         <Route path="/marklineservice" name="Mark Line services" element={<MarkLineServices/>} />
         <Route path="/construction" name="Civil Construction" element={<CivilConstruction/>} />
          <Route path="/maintenance" name="Routine Maintenance" element={<RoutineMaintenance/>} />
           <Route path="/fabrication" name="Fabrication & Erection" element={<FabricationErection/>} />
           <Route path="/KNGPage" name="KNG profile" element={<KNGPage/>} />
            <Route path="/teamandmachinery" name="Team and Machinery" element={<OurTeam/>} />
         <Route path="/contact" name="Contact" element={<Contact/>} />
         
         
          
        </Routes>
       
           <a
      href="https://wa.me/7972949437" 
        className="whatsapp-icon"
      target="_blank"
      rel="noopener noreferrer"
      title="Chat with us!"
    >
          <FaWhatsapp />
        </a>
        

{showScroll && (
  <button className="scroll-to-top show" onClick={scrollToTop}>
   <FaAnglesUp />
  </button>
)}


        </div>
     <WebFooter/>
      
    </BrowserRouter>
  )
}

export default App
